<template>
  <div class="work-box" @click="clickAreaFn($event)">
    <div id="occupied">
      <div class="back-list" @click="goBack">返回</div>
    </div>
    <!-- <div class="blank-box" v-if="loading">
      ...加载中
    </div> -->
    <!-- <div class="blank-box" v-if="!existWork">
      该作品不存在
    </div> -->
    <div class="work-detail" v-if="!loading && existWork">
      <div class="top-info">
        <p class="work-name">{{ detailData.name }}</p>
        <div class="author-info">
          <img :src="urlGet(authorInfo.headId)" />
          <span>作者：{{ authorInfo.nickname }}</span>
          <span>迷你号：{{ authorInfo.uin }}</span>
        </div>
        <div class="option-box">
          <div class="down btn-opt" @click="showCopyPop = true">
            <img src="../assets/images/btn_download.png" />
            下载
          </div>
          <div class="like btn-opt" @click="thumbUpFn()">
            <img src="../assets/images/btn_like.png" />
            {{ detailData.thumbUp }}
          </div>
          <div class="share btn-opt" @click="showSharePop = true">
            <img src="../assets/images/btn_share.png" />
            分享
          </div>
        </div>
      </div>
      <div class="work-content">
        <div class="good-box wrap" v-if="divisionId == 60">
          <p class="title">资源</p>
          <div class="type-tag">
            <p>类型：模型</p>
            <p v-if="detailData.tags">标签：{{ detailData.tags | getTags }}</p>
          </div>
          <div class="small-imgs">
            <img :src="img" v-for="(img, i) in goodCoverArr" :key="i" />
          </div>
        </div>
        <div class="introduce wrap">
          <p class="title">作品介绍</p>
          <div class="intro">{{ detailData.intro }}</div>
        </div>
        <div class="explain wrap" v-if="divisionId == 50">
          <p class="title">作品说明</p>
          <div class="intro">{{ detailData.context }}</div>
        </div>
        <div class="explain wrap" v-if="detailData.videoUrl">
          <p class="title">演示视频</p>
          <div class="intro">
            <a :href="detailData.videoUrl">{{ detailData.videoUrl }}</a>
          </div>
        </div>
        <div class="screenshot wrap">
          <p class="title">作品截图</p>
          <img
            class="screenshot-img"
            :src="img"
            v-for="(img, i) in imgsArr"
            :key="i"
          />
        </div>
      </div>
    </div>

    <van-popup v-model="showCopyPop" class="copy">
      <p>复制作者迷你号前往迷你工坊搜索，下载该地图查看！</p>
      <div class="copy-box">
        <p>作者迷你号：{{ copyTxt }}</p>
        <div
          class="btn-copy"
          id="copyText"
          :data-clipboard-text="copyTxt"
          @click="copyFn('uin', 'copyText')"
        >
          复制
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showSharePop" class="share-pop">
      <ul class="share-box center">
        <li @click="shareGameDynamic">
          <img src="../assets/images/share-dynamic.png" />
        </li>
        <li @click="shareFriendPop">
          <img src="../assets/images/share-friend.png" />
        </li>
        <li
          @click="copyFn('share', 'shareWeChat')"
          :data-clipboard-text="shareUrl"
          id="shareWeChat"
        >
          <img src="../assets/images/share-wechat.png" />
        </li>
        <li
          @click="copyFn('share', 'shareQQ')"
          :data-clipboard-text="shareUrl"
          id="shareQQ"
        >
          <img src="../assets/images/share-qq.png" />
        </li>
        <li @click="shareqonze">
          <img src="../assets/images/share-Qzone.png" />
        </li>
        <li @click="sharesina">
          <img src="../assets/images/share-sina.png" />
        </li>
      </ul>
    </van-popup>
    <van-popup
      v-model="showFriendListPop"
      position="bottom"
      :style="{ height: '45%' }"
    >
      <van-picker
        show-toolbar
        value-key="nickname"
        :columns="gameFriendArr"
        @confirm="confirmFriendPop"
      />
    </van-popup>
  </div>
</template>

<script>
import { ssoLoing } from '../common/ssoUrl';
import Clipboard from 'clipboard';
import { getAvatarUrl } from '../common/utils';
import { seasonId } from '../common/argumentId';
import { baseUrl } from '../api/baseUrl';
import ajax from '../api/ajax';
export default {
  name: 'workDeatil',
  data() {
    return {
      detailData: {},
      authorInfo: {},
      imgsArr: [],
      goodCoverArr: [],
      tipsTxt: '... 加载中',
      divisionId: this.$route.params.typeId,
      wid: this.$route.params.id,
      loading: false,
      existWork: false,
      copyTxt: '',
      showCopyPop: false,
      showSharePop: false,
      showFriendListPop: false,
      gameFriendArr: [],
      shareImgUrl:
        'https://image.mini1.cn/c/20201020/1f4dff83dbecd298719b745e114f527e.png',
      shareTitle: '这是分享标题',
      shareContent: '这是分享内容',
      shareUrl: window.location.href
    };
  },
  mounted() {
    window.sessionStorage.setItem(
      'pathName',
      window.location.hash.split('#')[1]
    );
    this.$scroll('occupied');
    this.queryDetail();
    this.getShareConfig();
  },
  computed: {
    isLogin() {
      if (window.sessionStorage.getItem('currentUser') != 'null') {
        this.$store.commit(
          'userStatus',
          JSON.parse(window.sessionStorage.getItem('currentUser'))
        );
      } else {
        this.$store.commit('userStatus', null);
      }
      return this.$store.getters.isLogin;
    }
  },
  methods: {
    async getShareConfig() {
      let body = {
        seasonId,
        divisionId: this.divisionId,
        wid: this.wid
      };
      try {
        const res = await this.$http.shareConfig(body);
        const { data } = res.data;
        this.shareImgUrl = data.img;
        this.shareTitle = data.title;
        this.shareContent = data.content;
        this.shareUrl = data.url;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取头像
    urlGet(val) {
      return getAvatarUrl(val);
    },
    async queryDetail() {
      let body = {
        seasonId,
        divisionId: this.divisionId,
        wid: this.wid
      };
      try {
        this.loading = true;
        const res = await this.$http.apiDetail(body);
        const { data } = res.data;
        if (data) {
          this.existWork = true;
          this.detailData = data;
          this.imgsArr = data.imgs.split(',');
          this.authorInfo = data.uinfo;
          this.copyTxt = this.authorInfo.uin;
          if (data.itemCovers) {
            this.goodCoverArr = data.itemCovers.split(',');
          }
        } else {
          this.existWork = false;
          this.tipsTxt = '该作品不存在';
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    // 复制文字
    copyFn(type, id) {
      var clipboard = new Clipboard(`#${id}`);
      clipboard.on('success', () => {
        // 释放内存
        clipboard.destroy();
        if (type == 'uin') {
          this.$Toast('复制成功');
          this.showCopyPop = false;
        } else {
          this.$Toast('已复制分享链接到粘贴板');
        }
      });
      clipboard.on('error', () => {
        // 不支持复制
        this.$Toast('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
        this.showCopyPop = false;
      });
    },
    async thumbUpFn() {
      if (this.isLogin) {
        try {
          const res = await ajax.post(
            `${baseUrl}/pu/v1/works/thumbUp?seasonId=${seasonId}&divisionId=${this.divisionId}&wid=${this.wid}`
          );
          this.$Toast(res.data.msg);
          if (res.data.code == 0) {
            this.queryDetail();
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        // this.$Toast('请先登录');
        ssoLoing();
      }
    },
    confirmFriendPop(val) {
      this.shareGameFriendFn(val.uin);
    },
    // 关闭面板
    clickAreaFn(e) {
      let targets1 = 'van-picker__confirm'; // 确认
      let targets2 = 'van-picker__cancel'; // 取消
      let targets3 = 'van-overlay van-fade-enter van-fade-enter-active'; // 面板外
      if (
        e.target.className == targets1 ||
        e.target.className == targets2 ||
        e.target.className == targets3
      ) {
        this.showFriendListPop = false;
      }
    },
    // 分享空间
    shareqonze() {
      window.open(
        `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?summary=${this.shareContent}&url=${this.shareUrl}&title=${this.shareTitle}&pics=${this.shareImgUrl}`
      );
    },
    // 分享微博
    sharesina() {
      window.open(
        `//service.weibo.com/share/share.php?url=${this.shareUrl}&title=${this.shareTitle}&pic=${this.shareImgUrl}`
      );
    },
    //好友列表弹窗
    shareFriendPop() {
      this.getFriendlist();
    },

    //好友列表
    async getFriendlist() {
      if (!this.isLogin) {
        // this.$Toast('请先登录');
        ssoLoing();
        return;
      }
      try {
        let body = {
          seasonId,
          divisionId: this.divisionId,
          wid: this.wid
        };
        const res = await this.$http.apiFriendList(body);
        if (res.data.code != 0) {
          this.$Toast(res.data.msg);
        } else {
          if (res.data.data.length) {
            this.gameFriendArr = res.data.data;
            this.showFriendListPop = true;
          } else {
            this.$Toast('暂无好友，请选择其他分享方式');
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 分享游戏内好友
    async shareGameFriendFn(fIds) {
      let body = {
        seasonId,
        divisionId: this.divisionId,
        wid: this.wid,
        fIds
      };
      try {
        const res = await this.$http.apiShareFriend(body);
        if (res.data.code == 0) {
          this.$Toast('分享成功');
          this.showSharePop = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 分享游戏动态
    async shareGameDynamic() {
      if (!this.isLogin) {
        ssoLoing();
        return;
      }
      let body = {
        seasonId,
        divisionId: this.divisionId,
        wid: this.wid
      };
      try {
        const res = await this.$http.apiShareDynamic(body);
        if (res.data.code == 0) {
          this.$Toast('分享成功');
          this.showSharePop = false;
        } else {
          this.$Toast(res.data.msg);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.work-box {
  width: 750px;
  font-size: 26px;
  padding: 20px;
  min-height: 550px;
  .blank-box {
    width: 750px;
    height: 1000px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
  }
}
.work-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .top-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    .work-name {
      color: #e8b152;
      font-size: 44px;
      font-weight: 600;
    }
    .author-info {
      width: 600px;
      margin: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-around;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .option-box {
      width: 750px;
      display: flex;
      justify-content: space-around;
      .btn-opt {
        width: 160px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-right: 10px;
        }
      }
      .down {
        color: #fff;
        background-color: #1cc382;
        img {
          width: 28px;
          height: 29px;
        }
      }
      .like {
        background-color: #fbbf64;
        img {
          width: 28px;
          height: 26px;
        }
      }
      .share {
        color: #fff;
        background-color: #21b8ed;
        img {
          width: 33px;
          height: 29px;
        }
      }
    }
  }
  .work-content {
    display: flex;
    flex-direction: column;
    .wrap {
      margin-top: 30px;
    }
    .title {
      font-size: 34px;
      font-weight: 600;
    }
    .good-box {
      .type-tag {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px;
      }
      .small-imgs {
        padding: 0 20px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        img {
          width: 140px;
          height: 140px;
          background: url('../assets/images/bg_resbg.png') no-repeat top
            center/140px 140px;
          margin-bottom: 20px;
        }
      }
    }
    .screenshot-img {
      width: 100%;
      margin-top: 10px;
    }
  }
}

.van-popup.copy {
  font-size: 28px;
  padding: 20px;
  width: 500px;
  height: 250px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  .copy-box {
    display: flex;
    align-items: center;
    .btn-copy {
      color: #fff;
      background-color: #ff874b;
      width: 120px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      margin-left: 20px;
      border-radius: 5px;
    }
  }
}
.share-pop {
  border-radius: 10px;
  .share-box {
    width: 500px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    li {
      width: 108px;
      height: 108px;
      margin: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 85px;
        height: 85px;
      }
    }
  }
}

/deep/ .van-picker-column,
/deep/ .van-picker__cancel,
/deep/ .van-picker__title,
/deep/ .van-picker__confirm {
  font-size: 34px;
}
/deep/ .van-picker__toolbar {
  height: 70px;
}
.intro {
  a {
    text-decoration: underline;
    color: #2440b3;
  }
}
#occupied {
  display: flex;
  align-items: flex-end;
  .back-list {
    height: 50px;
    width: 100px;
    color: #fff;
    font-size: 26px;
    border-radius: 5px;
    background-color: #ff874b;
    text-align: center;
    line-height: 50px;
  }
}
</style>
